import { Link, Outlet } from 'react-router-dom';
import { useMe } from '../lib/api';
import { Fox } from '../components/Fox';
import './admin.css';

/** App-owner area: its own dark top bar and no left rail. */
export function AdminLayout() {
  const me = useMe();
  const hasCompany = !!me.data;
  return (
    <div className="admin">
      <header className="admin-bar">
        <Fox size={28} />
        <span className="admin-bar__brand">
          Coach <span>Lex</span>
        </span>
        <span className="admin-chip">Admin</span>
        <span style={{ flex: 1 }} />
        {hasCompany && <Link to="/conversations">← Back to app</Link>}
        <span className="admin-avatar">{me.data?.user.initials ?? ''}</span>
      </header>
      <div className="admin-body">
        <Outlet />
      </div>
    </div>
  );
}
